import Vue from 'vue';
import Vuex from 'vuex';

import { authentication } from './authenticationModule';
import { booking } from './bookingModule';
import { user } from './userModule';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
        booking,
        user,
    }
});

export default store;